const DEFAULT_BACKEND_URL = typeof window !== "undefined"
  ? window.location.origin
  : "http://localhost:8000";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
  ? process.env.REACT_APP_BACKEND_URL.replace(/\/+$/, "")
  : DEFAULT_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;
